<div style="margin:20px">
    <p style="font-size: 24px;">Un-Authorized Access!</p>
    <p>
      You are not authorized to access this application, Please contact the application administrator to get the access.</p>
    <!-- <mc-button label="Login" (click)="login()">
    </mc-button> -->
</div>
